import { Layout } from 'antd'
import PropTypes from 'prop-types'
import { hot } from 'react-hot-loader'
import React from 'react'
import { Router, withSiteData } from 'react-static'
import Routes from 'react-static-routes'
import Footer from './components/Footer'
import Header from './components/Header'
import GlobalStyle from './styles/styled-global'
import { ThemeProvider } from 'styled-components'
import 'babel-polyfill'

// import '@babel/polyfill'
// import Community from './containers/Community'

const { Content } = Layout

let WebFont = {
  load: _ => {},
}

if (typeof window !== 'undefined') {
  WebFont = require('webfontloader')
}

const headerFooterColLayout = {
  xs: { span: 22, offset: 1 },
  sm: { span: 20, offset: 2 },
  md: { span: 20, offset: 2 },
  lg: { span: 20, offset: 2 },
  xl: { span: 20, offset: 2 },
  xxl: { span: 20, offset: 2 },
}

const headerColLayout = {
  xs: { span: 24 },
  sm: { span: 20 },
  md: { span: 18 },
  lg: { span: 18 },
  xl: { span: 16 },
  xxl: { span: 16 },
}

const headerStyle = {
  height: 'auto',
  background: 'linear-gradient(to bottom, #152336 0, #00000070 120%)',
}

class App extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  componentDidMount = () => {
    WebFont.load({
      google: {
        families: [
          'Saira:400,500,600,700,800,900',
          'Gruppo',
          'Orbitron:400,500,700,900',
          'Rajdhani:300,400,500,600,700',
          'Anton:400',
          'Kanit:700',
          'Monda:400,700',
          'Palanquin:100,200,300,400,500,600,700',
          'Alegreya Sans SC:100,300,400,500,700,800,900',
        ],
      },
    })
  }

  render() {
    const { site } = this.props.siteData

    const theme = Object.keys(site.colors).reduce((acc, curr) => {
      const { r, g, b, a } = site.colors[curr].rgb
      acc[curr] = `rgba(${r},${g},${b},${a})`
      return acc
    }, {})

    return (
      <ThemeProvider theme={theme}>
        <Router>
          <Layout>
            <Header style={headerStyle} colLayout={headerColLayout} />
            <Content>
              <Routes />
            </Content>
            <Footer colLayout={headerColLayout} />
            <GlobalStyle />
          </Layout>
        </Router>
      </ThemeProvider>
    )
  }
}

export default hot(module)(withSiteData(App))



// WEBPACK FOOTER //
// /opt/build/repo/src/App.tsx